import React, { useState, useEffect } from "react";
import { Row, Col, Accordion, Card, Button, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import SummaryCard from "./SummaryCard.jsx";
import classes from "./ItemSalesAnalysis.module.css";
import ReactExport from "react-export-excel-fixed-xlsx";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ItemSalesAnalysis = (props) => {
  const [AxiosError, setAxiosError] = useState("");
  const [RetrievedItemRecords, setRetrievedItemRecords] = useState([]);
  const [Title, setTitle] = useState("");
  const [DisplayData, setDisplayData] = useState(false);
  const [Rct, setRct] = useState({});
  const [IsPrinting, setIsPrinting] = useState(false);

  useEffect(() => {
    let Records = props.Records;
    let TotalSales = 0;
    let TotalBulk = 0;
    let TotalUnit = 0;
    let TotalProfit = 0;

    setRetrievedItemRecords(Records);
    setDisplayData(true);
    if (props.myDates.type === "specific") {
      setTitle((" for " + props.myDates.dates).toUpperCase());
    } else {
      let thedates = [...props.myDates.dates];
      setTitle(
        (
          "from " +
          thedates[0] +
          " to " +
          thedates[thedates.length - 1] +
          "."
        ).toUpperCase()
      );
    }
  }, []);

  const ExportToExcel = (ArrData, indx) => {
    return (
      <ExcelSheet
        data={ArrData.ThisItemRecords}
        name={ArrData.ThisDate}
        key={indx}
      >
        <ExcelColumn label="ITEM NAME" value="ItemName" />
        <ExcelColumn label="BULK" value="Bulk" />
        <ExcelColumn label="UNIT" value="Unit" />
        <ExcelColumn label="PROFIT" value="Profit" />
      </ExcelSheet>
    );
  };

  const getTableCode = (ArrData, ind) => {
    let DataPresent = true;
    if (
      ArrData.ThisItemRecords != undefined &&
      ArrData.ThisItemRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }

    return (
      <Row className="justify-content-around " key={ind}>
        <Col md={10} sm={11} xs={11}>
          <Accordion.Item eventKey={ind}>
            <Accordion.Header className={classes.TheHeader}>
              {ArrData.ThisDate}
            </Accordion.Header>
            <Accordion.Body>
              {DataPresent && (
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Item Name</th>
                      <th>Bulk</th>
                      <th>Unit</th>
                      {props.myDates.Category === "Group" && <th>Profit</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {ArrData.ThisItemRecords.map((rec, index) => (
                      <tr key={index}>
                        <td>
                          {index < ArrData.ThisItemRecords.length - 1
                            ? index + 1
                            : ""}
                        </td>
                        <td>{rec.ItemName}</td>
                        <td>{rec.Bulk}</td>
                        <td>{rec.Unit}</td>
                        {props.myDates.Category === "Group" && (
                          <td>{rec.Profit}</td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {!DataPresent && (
                <p style={{ color: "Red", fontSize: "15px" }}>
                  Oops! No Record for {ArrData.ThisDate}
                </p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Col>
      </Row>
    );
  };

  const TableForPrinting = (ArrData, indx) => {
    let DataPresent = true;
    if (
      ArrData.ThisItemRecords != undefined &&
      ArrData.ThisItemRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    return (
      <div key={indx}>
        {props.myDates.Category === "Individual" &&
          props.myDates.Staff.toUpperCase() + " "}
        ITEMS SALES REPORT FOR {ArrData.ThisDate.toUpperCase()}
        {DataPresent && (
          <Table
            striped
            bordered
            responsive
            key={indx}
            className={classes.table4printing}
          >
            <thead>
              <tr>
                <th>SN</th>
                <th>Item Name</th>
                <th>Bulk</th>
                <th>Unit</th>
                {props.myDates.Category === "Group" && <th>Profit</th>}
              </tr>
            </thead>
            <tbody>
              {ArrData.ThisItemRecords.map((rec, index) => (
                <tr key={index}>
                  <td>
                    {index < ArrData.ThisItemRecords.length - 1
                      ? index + 1
                      : ""}
                  </td>
                  <td>{rec.ItemName}</td>
                  <td>{rec.Bulk}</td>
                  <td>{rec.Unit}</td>
                  {props.myDates.Category === "Group" && <td>{rec.Profit}</td>}
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!DataPresent && <p>Oops! No Record for {ArrData.ThisDate}</p>}
        <hr />
      </div>
    );
  };

  const PrintTheReport = () => {
    setIsPrinting(true);
    window.print();
    setIsPrinting(false);
  };

  return (
    <Row>
      <Col md={12} sm={12} xs={12}>
        {DisplayData && (
          <Row className={classes.margin4printing}>
            <Col md={12} sm={12} xs={12} className={classes.hide4printing}>
              <p
                style={{
                  fontFamily: "Times New Roman",
                  fontSize: "20px",
                  color: "brown",
                  textAlign: "center",
                }}
              >
                {props.myDates.Category === "Individual" &&
                  props.myDates.Staff.toUpperCase() + " "}
                Item SALES REPORTS {Title}
              </p>
            </Col>

            <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
              <Row
                className={`${
                  classes.margin4printing
                } ${"justify-content-around"}`}
              >
                <Col md={12} sm={12} xs={12} className={classes.hide4printing}>
                  <Accordion>
                    {props.myDates.type === "specific"
                      ? getTableCode(RetrievedItemRecords, 0)
                      : RetrievedItemRecords.map((rtrvrec, index) =>
                          getTableCode(rtrvrec, index)
                        )}
                  </Accordion>
                </Col>
                <Col
                  md={12}
                  sm={12}
                  xs={12}
                  className={classes.margin4printing}
                >
                  {IsPrinting
                    ? props.myDates.type === "specific"
                      ? TableForPrinting(RetrievedItemRecords, 0)
                      : RetrievedItemRecords.map((rtrvrec, index) =>
                          TableForPrinting(rtrvrec, index)
                        )
                    : null}
                </Col>
                <hr className={`${classes.hide4printing} ${"mx-2"}`} />

                <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                  <Button variant="info" onClick={PrintTheReport}>
                    PRINT REPORT
                  </Button>
                </Col>

                <Col md={2} sm={12} xs={12} className={classes.hide4printing}>
                  <ExcelFile
                    element={
                      <Button variant="info" className="my-2">
                        EXPORT TO EXCEL
                      </Button>
                    }
                    filename={
                      (props.myDates.Category === "Individual"
                        ? props.myDates.Staff.toUpperCase()
                        : "") +
                      "ITEM SALES REPORT FOR " +
                      (props.myDates.type === "specific"
                        ? RetrievedItemRecords.ThisDate
                        : RetrievedItemRecords[0].ThisDate +
                          "-" +
                          RetrievedItemRecords[RetrievedItemRecords.length - 1]
                            .ThisDate
                      ).toUpperCase()
                    }
                  >
                    {props.myDates.type === "specific"
                      ? ExportToExcel(RetrievedItemRecords, 0)
                      : RetrievedItemRecords.map((rtvdata, ind) =>
                          ExportToExcel(rtvdata, ind)
                        )}
                  </ExcelFile>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default ItemSalesAnalysis;
